import { AuthForm } from '@/components/auth-form';
import { VerifyEmailContent } from '@/components/verify-email/VerifyEmailContent';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AxiosError } from 'axios';
import { useState } from 'react';

export const Route = createFileRoute('/verify-email/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      email: search.email as string | undefined,
      redirect: search.redirect as string | undefined,
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Verify Email - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const { email, redirect: redirectUrl } = Route.useSearch();
  const [formError, setFormError] = useState<AxiosError | undefined>(undefined);

  // If no email is provided, redirect to login
  if (!email) {
    navigate({
      to: '/login',
      search: { redirect: redirectUrl },
    });
    return null;
  }

  return (
    <AuthForm error={formError}>
      <VerifyEmailContent
        email={email}
        redirectUrl={redirectUrl}
        onError={setFormError}
        autoSendInitialVerification={true}
      />
    </AuthForm>
  );
}
